export default {
    foldingTypes: [],
    foldingTypesLoading: false,
    impositionTaskFoldingTypes: [],
    impositionTaskFoldingTypesLoading: false,
    lastImpositionTaskQuery: ''
}